import React from 'react';

const Marquee = () => {
  const items = [
    '3D Mobile Apps',
    'React & Three.js',
    'iOS & Android Tech',
    'Responsive Design',
    'Full-Stack Architecture',
    'SEO & Performance',
    'Digital Transformation',
    'Custom ERP & POS Solutions',
  ];

  return (
    <div className="py-6 bg-gradient-to-r from-purple-100 via-indigo-50 to-pink-100 border-y border-purple-200 overflow-hidden relative">
      <div className="animate-marquee flex items-center space-x-8 whitespace-nowrap">
        {[...items, ...items].map((item, index) => (
          <div key={index} className="flex items-center space-x-6">
            <span className="text-sm md:text-base font-bold font-display tracking-wider uppercase text-purple-900">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-purple-500 shadow-sm" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
